import React, { useState } from "react";
import axios from "../../../../axios";
const ResolveQueryLib = ({ close,data }) => {
  const handleStatusChange=async()=>{
    let res=await axios.put(`/query/updateStatusForStudent/${data?.id}`,{"status":"resolved"});
    if(res.status===true){
      window.location.reload();
    }
  }
  return (
    <div className=" delete_query_transprant_body ">
      <img
        src="/images/cross-circle3.svg"
        className=" delete_query_close_btn"
        alt=""
        onClick={() => { close() }}
      />
      <div className=" p-3 d-flex align-items-center justify-content-center flex-column delete_query_container shadow">
        <div className=" col-12 d-flex align-items-center justify-content-center flex-column text-center">
          <span className="mt-4 mb-5 delete_query_text">
            Are you sure you want to mark as resolve this Query?
          </span>
          <div className="col-12 p-0 gap-3 flex-wrap d-flex justify-content-center ">
            <button
              className="btn btn-danger col-sm-5 query_delete_btn"
              onClick={()=>{handleStatusChange()}}
            >
              Yes
            </button>
            <button
              className="btn btn-danger col-sm-5 query_delete_btn default_deleteq_uery_no"
              autoFocus
              onClick={() => { close() }}

            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResolveQueryLib;
